package com.alpha.showcase.common.ui.ai

import androidx.compose.runtime.Composable

@Composable
internal actual fun AiPreviewSystemBars(chromeVisible: Boolean) = Unit
